import { Injectable } from '@angular/core';


const fixedColorList: [number, number, number][] = [
  [176, 23, 31],
  [139, 99, 108],
  [0, 0, 128],
  [0, 139, 69],
  [139, 139, 0],
  [205, 133, 0],
  [238, 64, 0],
  [205, 0, 0],
  [22, 22, 22],
  [205, 16, 118],
  [105, 89, 205],
  [24, 116, 205],
  [69, 139, 0],
  [139, 90, 0],
  [238, 160, 80],
  [205, 85, 85],
  [113, 113, 198],
  [163, 163, 163],
  [127, 255, 0],
  [0, 205, 205]
];

@Injectable()
export class ColorService {

  constructor() { }

  getMany(count: number): Color[] {
    const out: Color[] = [];

    if (count <= fixedColorList.length) {
      for (let i = 0; i < count; i++) {
        out.push({ hex: this.hexColorFromColorArray(fixedColorList[i]), rgb: fixedColorList[i] });
      }
      // out = fixedColorList.map(c => { return { hex: this.hexColorFromColorArray(c), rgb: c }; }).slice(0, count - 1);
    } else {
      fixedColorList.forEach(c => {
        out.push({ hex: this.hexColorFromColorArray(c), rgb: c });
      });
      for (let i = 0; i < (count - fixedColorList.length); i++) {
        const odd = ((i % 2) === 0);
        const m3 = ((i % 3) === 0);
        const a = Math.round(i / count * 255);
        const b = Math.round((count - i) / count * 255);
        const rgb = [
          ((odd === true) ? a : b),
          ((odd === true) ? b : a),
          ((odd === true || m3 === false) ? a : b)
        ];
        out.push({ hex: this.hexColorFromColorArray(rgb), rgb: rgb });
      }
    }
    return out;
  }

  hexColorFromColorArray(color: number[]) {
    return '#' + ('0' + (color[0] & 0xFF).toString(16)).slice(-2)
      + ('0' + (color[1] & 0xFF).toString(16)).slice(-2)
      + ('0' + (color[2] & 0xFF).toString(16)).slice(-2);
  }

}

export interface Color {
  hex: string;
  rgb: number[];
}




// WEBPACK FOOTER //
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/services/color.service.ts